<template>
    <div style="display: flex; height: 100%; ">
        <v-row style="margin: 0px; height: 80%; align-self: center;">
            <v-col class="tableau">
                <v-data-table  
                        class="moduleTable"
                        :items="modules" 
                        :headers="headerModules" 
                        :items-per-page="-1"
                        fixed-header 
                        hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_modules_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                        small
                        @click.stop="deleteItem(item)"
                        >
                        mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

            </v-col>
            <v-col class="formulaire">
                <!-- <v-btn @click="this.openModal" class="ajoutModeleBouton">
                            <div >{{$t("_je_ne_trouve_pas_mon_module_")}}</div>
                        </v-btn> -->
                        <div class="questions">
                        <div class="champs">
                            <div>
                                {{$t("_reference_du_modele_")}} (*)
                            </div>
                            <div class="input inputField">
                                <v-autocomplete
                                    v-model="reponse.ref.value"
                                    :items="filteredPvListe"
                                    :search-input.sync="searchModule"
                                    item-text="data.key"
                                    :return-object="true"
                                    color="orange"
                                    outlined
                                    attach
                                    no-filter
                                    clearable
                                    :multiple="false"
                                ></v-autocomplete>
                                </div>
                        </div>
            
                        <v-btn :disabled="!rempli" style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;" @click="addData()">
                            {{$t("_ajouter_")}}
                        </v-btn>
                        
    </div>
            </v-col>
        </v-row>
        <PopUpAjouterModele v-if="this.modalAjout" :type="'module'" @saveModel="save" @close="modalAjout=false">
            <template v-slot:title>
                {{$t("_ajouter_un_nouveau_module_a_la_liste_")}}
            </template>
        </PopUpAjouterModele>
    </div>
</template>

<script>
import api from "@/api/api";
import PopUpAjouterModele from "./PopUpAjouterModele.vue";


export default {
    // ... (props, components, mounted) ...
    props: {
        initModules : {
            required: false,
        },
        install_id: {
            required: true
        },
        initCalepinage: {
            required: false
        }
    },

    components: {
        PopUpAjouterModele,
    },

    data() {
        return {
            modules: [],
            pvListe: [],
            calepinage: [],
            headerModules: [
                { key: 'ref', text: this.$t('_reference_du_modele_'), value: 'ref' },
                { key: 'puissanceNominale', text: this.$t('_puissance_nominale_'), value: 'puissanceNominale' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            // rempli: false, // <-- Supprimé de data
            reponse: {
                "id": { "value": "", "required": false },
                "ref":  { "value": "", "required": true }, // Sera un objet, null, ou ""
                "puissanceNominale":  { "value": "", "required": false },
            },
            reponseVide: {
                "id": { "value": "", "required": false },
                "ref":  { "value": "", "required": true },
                "puissanceNominale":  { "value": "", "required": false },
            },
            modalAjout: false,
            searchModule: null, 
        }
    },

    async mounted(){
        // ... (votre code mounted inchangé) ...
        if (this.initModules !== undefined && this.initModules !== null) 
            this.modules = this.initModules
        if (this.initCalepinage !== undefined && this.initCalepinage !== null)
            this.calepinage = this.initCalepinage
        this.pvListe= await api.get_pv_panel_model()

        try{
            const reponse = (await api.get_models_modules(this.install_id)).data
            reponse.forEach(element => {
                this.pvListe.push(element)
            });
        }
        catch{
            console.log("Pas de module ajouté")
        }
    },

    computed: {
        filteredPvListe() {
            if (!this.searchModule) {
                return this.pvListe;
            }
            const searchLower = this.searchModule.toLowerCase();
            return this.pvListe.filter(modele => {
                const key = modele.data.key ? modele.data.key.toLowerCase() : '';
                return key.includes(searchLower); 
            });
        },

        // ### PROPRIÉTÉ COMPUTED "rempli" CORRIGÉE ###
        rempli() {
            // 1. Vérifier si un module valide est sélectionné
            const selectedModule = this.reponse.ref.value;
            
            if (!selectedModule || typeof selectedModule !== 'object' || !selectedModule.data) {
                // Si aucun module n'est sélectionné (c'est null, "", ou invalide)
                return false;
            }

            // 2. Puisqu'il n'y a pas d'autres champs requis dépendants (comme nbMppt), 
            // si un objet valide est sélectionné, le formulaire est rempli.
            return true;
        }
    },

    methods: {

        // ### MÉTHODE "addData" CORRIGÉE ###
        addData() {
                if (!this.rempli){
                    return;
                }
                const selectedModuleObject = this.reponse.ref.value; 
                if (!selectedModuleObject || !selectedModuleObject.data || !selectedModuleObject.data.key) {
                    console.error("Module sélectionné invalide ou incomplet.");
                    return;
                }
                const refString = selectedModuleObject.data.key;

                this.reponse.id.value = this.modules.length + 1
                const parts = refString.split("-") 
                this.reponse.puissanceNominale.value = parts[parts.length - 1]
                
                var justeValeurs = {}
                justeValeurs["id"] = this.reponse["id"].value
                justeValeurs["ref"] = refString; // On garde la string pour l'affichage tableau
                justeValeurs["puissanceNominale"] = this.reponse["puissanceNominale"].value
                justeValeurs["moduleDetails"] = selectedModuleObject;
                this.modules.push(justeValeurs)
                this.$nextTick(() => {
                    this.reponse.ref.value = null;
                    this.reponse.puissanceNominale.value = "";
                    this.searchModule = null;
                })
                this.$emit("answer", {"reponse" :this.modules, "calepinage": this.calepinage})
            },

        // ... (deleteItem, openModal, save - inchangés) ...
        // deleteItem fonctionne toujours car il compare item.ref (qui est une chaîne 
        // grâce à addData) avec calp.typeModule.
        deleteItem(item){
            this.modules.splice(this.modules.indexOf(item), 1)
            this.$nextTick(() => {
                for (var i=0; i<this.modules.length; i+=1){
                    this.modules[i].id = i + 1
                }
            })
            let newCalepinage= []
            this.calepinage.forEach(calp => {
                if (calp.typeModule!== item.ref){
                        newCalepinage.push(calp)
                    }
            })
            for (var i = 0; i < newCalepinage.length; i += 1) {
                newCalepinage[i].id = i + 1
            }
            // Retiré la logique d'édition pour la clarté
            this.calepinage=newCalepinage
            this.$emit("answer", {"reponse" :this.modules, "calepinage": this.calepinage})
        },
        openModal(){
            this.modalAjout = true
        },
        save(modele){
            this.pvListe.unshift(modele)
            api.post_model_module(this.install_id, modele)
            this.modalAjout = false
        }
    },
    watch: {
        modules: {
            handler(){
                if (this.modules.length > 0){
                    this.$emit('enable')
                }
                else {
                    this.$emit('disable')
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>

.input {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    display: flex;
    align-items: center;
}

.createSelect {
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 4px;
    padding: 8px;
    outline: none;
}

.input:focus-within {
    border: none !important;
    outline: none !important;
}

.tableau {
    align-content: center;
    height: 100%;
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47,47,47,0.5);
    border-radius: 5px;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.moduleTable{
    height: 100%;
}

.moduleTable >>> .lineEdit {
    background-color: #d9d9d9;
}

.inputCols{
    height: 100%;
}

.formulaire {
    position: relative;
}

.unit{
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}

.questions {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    padding: 10px;   
    min-width: 70%;
}

.ajoutModeleBouton {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px; 
    background-color: #d9d9d9;
    font-size: medium;
}

</style>